import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';
import { flowPickersItemStyle } from './datecalendar.theme';

export const flowMonthCalendar: Components<Theme>['MuiMonthCalendar'] = {
  styleOverrides: {
    root: {
      width: '100%',
      overflowX: 'hidden',
      maxHeight: '339px',
      padding: '16px 0',
    },
    button: ({ theme }) => ({
      position: 'relative',
      ...flowPickersItemStyle(theme),
      borderRadius: '1000px',
      margin: '0 8px',
    }),
  },
};
